'use strict';

const damHelper = require('./dam/dam-helper');

const loseGiftGuestWarning = {
    def: {
        guestCheckoutForm: '.js-guest-checkout-form'
    },

    createBonusWarningDialog: function (guestGwpProductName, guestGwpImage) {
        window.eventBus.$emit('shouldOpenModal', {
            paragraphs: [{
                    text: window.Resources.REMOVE_GIFT_EXPLANATION,
                    textLarge: true
                },
                {
                    text: window.Resources.REMOVE_GIFT_QUESTION,
                    textLarge: true
                }
            ],
            productImage: {
                src: guestGwpImage.src,
                alt: guestGwpProductName,
                class: guestGwpImage.class,
                placeholder: guestGwpImage.placeholder,
            },
            buttons: [{
                    type: 'btn btn--secondary',
                    label: window.Resources.MODAL_NO,
                    eventName: 'onCancelLoseGiftButtonClick',
                    shouldCloseModal: true
                },
                {
                    type: 'btn',
                    label: window.Resources.MODAL_YES,
                    eventName: 'onConfirmLoseGiftButtonClick',
                    shouldCloseModal: true
                }
            ],
            row: {
                class: 'center-align'
            },
            closeElement: {
                shouldCloseModal: true
            },
            ctaHolder: {},
            modalLarge: true,
            ctaHolderRow: true
        });

        window.eventBus.$on('onConfirmLoseGiftButtonClick', function () {
            $(document).off('submit.popup', '.js-guest-checkout-form');
            $('.js-guest-checkout-form').find('button').click();
        });

        window.eventBus.$on('onCancelLoseGiftButtonClick', function () {
            const button = $('#btn-checkout-guest');
            button.removeClass('button-loading');
            $('.js-spinner-general', button).removeClass('spinner-visible');
        });

        window.eventBus.$off('modalOpen').$on('modalOpen', function () {
            damHelper.updateImages($('#modal'));
        });
    },

    events: function () {
        $(document).off('submit.popup', loseGiftGuestWarning.def.guestCheckoutForm).on('submit.popup', loseGiftGuestWarning.def.guestCheckoutForm, function (e) {
            const button = $('button[type=submit]', this);
            button.addClass('button-loading');
            $('.js-spinner-general', button).addClass('spinner-visible');
            const guestGwpProductName = $('#js-gwp-for-guest-product-name').val();

            const $guestGWPProductImage = $('#js-gwp-for-guest-product-image');
            if (!$guestGWPProductImage.length) {
                return true;
            }

            const productImage = JSON.parse($guestGWPProductImage.val());

            e.preventDefault();
            loseGiftGuestWarning.createBonusWarningDialog(guestGwpProductName, productImage);
        });
    },

    init: function () {
        loseGiftGuestWarning.events();
    }
};

module.exports = loseGiftGuestWarning;
